import React from 'react';
import goldStar from "../../../../assets/icons/gold_star.png";
import halfStar from "../../../../assets/icons/half_star.png";
import emptyStar from "../../../../assets/icons/grey_star.png";

const StarRating = ({ rating }) => {
    const roundedRating = Math.floor(rating * 2) / 2; // round down to nearest 0.5

    const fullStars = Math.floor(roundedRating);
    const hasHalfStar = roundedRating - fullStars === 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    const stars = [];
    // console.log("Stars : ",stars)

    for (let i = 0; i < fullStars; i++) {
        stars.push(<img key={`full-${i}`} src={goldStar} alt="Full Star" />);
    }

    if (hasHalfStar) {
        stars.push(<img key="half" src={halfStar} alt="Half Star" />);
    }

    for (let i = 0; i < emptyStars; i++) {
        stars.push(<img key={`empty-${i}`} src={emptyStar} alt="Empty Star" />);
    }

    return <div className="food-card-stars">{stars}</div>;
};


export default StarRating;
